import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/home/yourprofile',
  exact: true,
  name: 'navigation.menu.profile',
  private: true,
  type: containerTypes.CONTENT,
};

export default RouteConfig;
